import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleMobileMenu } from '../../Actions/Navigation.action';
import Icon from '../Icon';
import SideMenu from '../SideMenu/SideMenu';
import MobileNavigationItem from './ui/MobileNavigationItem';
import { translate } from '../../Services/translation';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import styled, { createGlobalStyle } from 'styled-components';
import { getColor } from '../../styling/mixins/colors';
import { StyledSideMenuContent } from '../SideMenu/styles/SideMenu.styling';
import { breakpoint } from '../../styling/mixins/breakpoints';
import { fontFamily } from '../../styling/variables/typography';

const StyledSideMenu = styled(SideMenu)`
  z-index: 60;
  height: calc(100% - 67px);
  .sidemenu-header__wrapper{
    padding: 0!important;
  }
  ${breakpoint('medium')}{
    max-width: 480px;
  }
`;

const StyledMenuIcon = styled(Icon)`
  font-size: 2.4rem;
  width: 25px;
  height: 25px;
  color: ${getColor('grey', 900)};
`;

const StyledCloseIcon = styled.div`
  padding: 1.5rem;
  border-left: 1px solid ${getColor('grey', 700)};
  cursor: pointer;
  margin: -1.6rem; //override standard side-menu-header padding
`;

const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  padding: 0;
  background-color: ${getColor('gray', 800)};
  padding: 1.6rem;
`;

const StyledHeaderImg = styled.img`
  max-height: 32px;
`;

const StyledContent = styled(StyledSideMenuContent)`
  padding: 0;
  display: flex;
  flex-direction: column;
  // gap: 5rem;
  overflow-y: scroll;
  gap: 0;
`;

const StyledIconWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  flex: 1;
  font-size: 24px;
  color: ${getColor('white')};
  ${fontFamily}
  font-size: 14px;
  line-height: 17px;
`;

const StyledLinks = styled.ul`
  display: flex;
  flex-direction: column;
`;

const StyledSocialWrapper = styled.div`
  display: flex;
  // gap: 1.6rem;
  & img {
    cursor: pointer;
  }
`;

const GlobalNavigationMobileStyling = createGlobalStyle`
  body #overlay-container .overlay--navigation-mobile {
    z-index: 55;
  }
`;

const Divider = styled.span`
  background-color: ${getColor('grey', 100)};
  height: 20px;
  width: 100%;
  padding: 16px 0px;
  border: 1px solid ${getColor('grey', 300)};
`

interface NavigationState {
  navigation: {
    mobileMenuOpen: boolean,
    mobileMenuCurrentCategory: string
    mobileMenuLinks: any
  }
}

const NavigationMobile = () => {
  const dispatch = useDispatch();
  const { mobileMenuOpen, logoUrl } = useTypedSelector<any>(
    (state) => state.navigation
  );

  const { contentLinks, rightContentLinks } = useSelector<NavigationState, any>((state) => {
    return state.navigation
  });

  const [currentLink, setCurrentLink] = useState<any>();
  const [previousLink, setPreviousLink] = useState<any>();

  const Header = () => (
    <StyledHeader>
      {!currentLink && (
        <>
          <StyledHeaderImg src={logoUrl} alt="Logo" loading="lazy" />
          <StyledCloseIcon onClick={() => dispatch(toggleMobileMenu(false))}>
            <StyledMenuIcon name="close-nav" />
          </StyledCloseIcon>
        </>
      )}
      {currentLink && (
        <>
          <StyledIconWrapper onClick={onBackClick}>
            <StyledMenuIcon name="chevron-left-nav" />
            {translate('general.back')}
          </StyledIconWrapper>
          <StyledCloseIcon onClick={() => dispatch(toggleMobileMenu(false))}>
            <StyledMenuIcon name="close-nav" />
          </StyledCloseIcon>
        </>
      )}
    </StyledHeader>
  );

  const Content = () => (
    <StyledContent>
      <StyledLinks>
        {menuLinks.map((link) => (
          <MobileNavigationItem
            link={link}
            key={'mobile' + link.url + link.name}
            onLinkClick={onLinkClick}
          />
        ))}
      </StyledLinks>
      {!currentLink && (
        <>
          <Divider />
          <StyledLinks>
            {rightContentLinks.map((link) => (
              <MobileNavigationItem
                link={link}
                key={'mobile' + link.url + link.name}
                onLinkClick={onLinkClick}
              />
            ))}
          </StyledLinks>
        </>
      )}
    </StyledContent >
  );

  const footer = () => (
    <></>

  );
  const onLinkClick = (link) => {
    link.previousLink = previousLink;
    setPreviousLink(currentLink);
    setCurrentLink(link);
  };
  const onBackClick = () => {
    setPreviousLink(previousLink?.previousLink);
    setCurrentLink(previousLink);
  };
  const menuLinks = (currentLink?.links ?? contentLinks).filter(
    (l) => !l.rightAligned
  );
  useEffect(() => {
    if (mobileMenuOpen) {
      setCurrentLink(null);
    }
  }, [mobileMenuOpen]);
  return (
    <>
      <StyledSideMenu
        from="left"
        id="navigation-mobile"
        open={mobileMenuOpen}
        onClosed={() => dispatch(toggleMobileMenu(false))}
        components={{ Header, Content }}
        showCloseButton={false}
      >
      </StyledSideMenu>
      <GlobalNavigationMobileStyling />
    </>
  );
};
export default NavigationMobile;
